import { useState, useEffect } from 'react';
import * as React from 'react';

interface Props {
  /** The number of milliseconds after which the component will be shown */
  showAfterMs?: number;
  /** The number of milliseconds after which the component will be hidden */
  hideAfterMs?: number;
  /** Override check before hiding the component */
  retainIf?: () => boolean;
  /** Callback when the component is shown */
  onShow?: () => void;
  /** Callback when the component is hidden */
  onHide?: () => void;
  children: React.ReactNode;
}

export const TimedRender = ({
  showAfterMs: showAfter,
  hideAfterMs: hideAfter,
  onShow,
  onHide,
  retainIf,
  children,
}: Props) => {
  const [show, setShow] = useState(!showAfter);

  useEffect(() => {
    const id1 = showAfter
      ? setTimeout(() => {
          setShow(true);
          onShow?.();
        }, showAfter)
      : -1;
    const id2 = hideAfter
      ? setTimeout(() => {
          const shouldHide = retainIf ? !retainIf() : true;

          if (shouldHide) {
            setShow(false);
            onHide?.();
          }
        }, hideAfter)
      : -1;

    return () => {
      clearTimeout(id1);
      clearTimeout(id2);
    };
  }, [showAfter, hideAfter, retainIf, onShow, onHide]);

  return show ? <>{children}</> : null;
};
